import { render, staticRenderFns } from "./PathwayNodesHeader.vue?vue&type=template&id=1a77830f"
import script from "./PathwayNodesHeader.vue?vue&type=script&lang=js"
export * from "./PathwayNodesHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports